import React from 'react';

interface SuccessCheckProps {
  /** Pixel size of the SVG. Default: 48 */
  size?: number;
}

/** Animated checkmark with circle draw. Uses .success-check CSS from App.css. */
const SuccessCheck: React.FC<SuccessCheckProps> = ({ size = 48 }) => (
  <svg
    className="success-check"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      stroke="var(--badge-green-text)"
      strokeWidth="1.5"
      fill="none"
    />
    <polyline
      points="7.5 12.5 10.5 15.5 16.5 9.5"
      stroke="var(--badge-green-text)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </svg>
);

export default SuccessCheck;
